import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/models/api-response.model';
import { FasttrackActivityLogs } from '@core/models/fasttrack-activity-logs.model';
import { Pagination } from '@core/models/pagination.model';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FasttrackActivityLogsDataService {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(
    private http: HttpClient
  ) { }

  getWithQuery(params: string): Observable<FasttrackActivityLogs[]> {
    return this.http.get<ApiResponse>(`/fasttrack/activity-log?${params}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
